/**
 * Breekpunten van de actiebalk, op één plek (besluit N2, UX-review 20 oktober 2026).
 *
 * ActionBar (alle panes): onder 340 px "tight" (de kleine knopmaat, geen groepslabels), onder 440 px
 * "compact", daarboven "full". Maat M (knop 48 × 40, icoon 24, groepslabel 11 px) geldt voor compact en
 * full; de maat zelf staat in pane.css.
 *
 * De DocSense-onderbalk van Snap en Sense (tot die op de ActionBar staat, traject 3) deelt de grens van
 * 340 px voor zijn brede stand, heeft daaronder nog een middenstand vanaf 280 px, en klapt zijn groepen
 * in op 460 / 380 / 300 px (DensityContext.tsx leest deze waarden hier).
 *
 * Zuiver (geen DOM), zodat de engine-tests de grenzen kunnen vastleggen.
 */

export const BAR_TIGHT_BELOW = 340;
export const BAR_COMPACT_BELOW = 440;

export type ActionBarDensity = "full" | "compact" | "tight";

/** Dichtheid van de ActionBar bij een balkbreedte in CSS-pixels. */
export function actionBarDensity(width: number): ActionBarDensity {
  if (width < BAR_TIGHT_BELOW) return "tight";
  if (width < BAR_COMPACT_BELOW) return "compact";
  return "full";
}

/** DocSense-onderbalk: middenstand vanaf hier, brede stand vanaf BAR_TIGHT_BELOW. */
export const DOCSENSE_MEDIUM_FROM = 280;
/** DocSense-onderbalk: inklapstap 1, 2 en 3 onder deze breedtes. */
export const DOCSENSE_COLLAPSE_BELOW: readonly [number, number, number] = [460, 380, 300];

/** Inklapstap van de DocSense-onderbalk bij een breedte (0 = nog niet gemeten → geen stap). */
export function docsenseCollapseStage(width: number): number {
  if (width === 0) return 0;
  let stage = 0;
  for (const bound of DOCSENSE_COLLAPSE_BELOW) if (width < bound) stage++;
  return stage;
}
